const headerCl = {
  headerWrapper: "header-sticky-js",
  headerWrapperHidden: "header-sticky-hidden-js",
  headerWrapperSticky: "header-sticky-visible-js",
};

let previousPosition = 0;

const determineScrollPosition = function (headerWrapper) {
  const currentPosition = window.scrollY;
  if (currentPosition > previousPosition) {
    headerWrapper.classList.remove(headerCl.headerWrapperSticky);
    previousPosition = currentPosition;
  } else {
    headerWrapper.classList.add(headerCl.headerWrapperSticky);
    previousPosition = currentPosition;
  }
};

export default function () {
  const headerStickyEl = document.querySelector("." + headerCl.headerWrapper);
  let headerStickyElHeight;

  window.addEventListener("load", () => {
    headerStickyElHeight = headerStickyEl.getBoundingClientRect().height;
    headerStickyEl.parentElement.style.paddingTop = headerStickyElHeight + "px";
    headerStickyEl.style.position = "fixed";
    document.querySelector('#clear-all').setAttribute('data-padding',  headerStickyElHeight + "px");
  });

  let scrollRunning = false;
  document.addEventListener("scroll", () => {
    if (scrollRunning) return;
    scrollRunning = true;
    setTimeout(() => {
      if (window.scrollY > headerStickyElHeight * 1.2) {
        headerStickyEl.classList.add(headerCl.headerWrapperHidden);
        determineScrollPosition(headerStickyEl);
      } else {
        headerStickyEl.classList.remove(headerCl.headerWrapperHidden);
      }
      scrollRunning = false;
    }, 100);
  });

  let resizeRunning = false;
  window.addEventListener("resize", () => {
    if (resizeRunning) return;
    resizeRunning = true;
    setTimeout(() => {
      headerStickyElHeight = headerStickyEl.getBoundingClientRect().height;
      headerStickyEl.parentElement.style.paddingTop =
        headerStickyElHeight + "px";
        // document.querySelector('#clear-all').setAttribute('data-padding',  headerStickyElHeight + "px");
      resizeRunning = false;
      
    }, 200);
  });
}
